import React from 'react';
import { useSetting } from '../../state/hooks/settings';
import { settingsAtom } from '../../state/settings';
import { MembersDrawer } from '../room/MembersDrawer';
import { useRoomMembersCtx } from '../../contexts/RoomMembersContext';
import { useMatrixClient } from '../../hooks/useMatrixClient';
import { useRoomMembers } from '../../hooks/useRoomMembers';
import { SidePanelBlock } from './SidePanelBlock';

export function MembersPanel() {
  const [isDrawer] = useSetting(settingsAtom, 'isPeopleDrawer');
  const { room } = useRoomMembersCtx();
  const mx = useMatrixClient();
  const members = useRoomMembers(mx, room?.roomId ?? '');

  if (!isDrawer || !room) return null;

  return (
    <SidePanelBlock>
      <MembersDrawer
        key={room.roomId}
        room={room}
        members={members}
      />
    </SidePanelBlock>
  );
}
